import { render, staticRenderFns } from "./CvsRecording.vue?vue&type=template&id=74a0ffde&scoped=true"
import script from "./CvsRecording.vue?vue&type=script&lang=js"
export * from "./CvsRecording.vue?vue&type=script&lang=js"
import style0 from "./CvsRecording.vue?vue&type=style&index=0&id=74a0ffde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a0ffde",
  null
  
)

export default component.exports